// =============================================================================
// Request & Response Model
// =============================================================================
import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { POST_NOTIFICATION_REPORT } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

export interface PostNotificationReportRequest {
  startDate: string;
  endDate: string;
  sentStatus: string;
  featureType: string;
  portalType: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: any) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostNotificationReport = ({ onSuccess, onError }: Input = {}) => {
  const PostNotificationReport = async (reqBody: PostNotificationReportRequest) => {
    const res = await axiosClient.post(POST_NOTIFICATION_REPORT, reqBody);
    return res.data;
  };
  return useCustomMutation(PostNotificationReport, {
    onSuccess,
    onError,
  });
};
